import { ref } from "vue";

export function useSort() {
    const searchText = ref('')

    function setSearch(v) {
        searchText.value = v
    }

    const selectedSort = ref(null)

    function setSort(v) {
        selectedSort.value = v
    }

    const sortOrder = ref(null)

    function setSortOrder(v) {
        sortOrder.value = v
    }

    return { searchText, setSearch, selectedSort, setSort, sortOrder, setSortOrder }
}

const id = ref(0)

export function useUnique() {
    function getUnique() {
        const i = ++id.value
        if (i > 10000) {
            id.value = 0
        }
        return i
    }

    const names = ref({})

    function getId(name) {
        if (!names.value.hasOwnProperty(name)) {
            names.value[name] = getUnique()
        }
        return name + '-' + names.value[name]
    }

    return { getUnique, getId }
}